<template>
  <div class="app-container">
    <el-form :model="queryParams" class="multipleSelectScroll" ref="queryForm" v-show="showSearch" label-width="100px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="合同编号" prop="contractNum">
            <el-input v-model="queryParams.contractNum" placeholder="请输入合同编号" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="签约客户" prop="customerName">
            <el-input v-model="queryParams.customerName" placeholder="请输入客户名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机" prop="businessName">
            <el-input v-model="queryParams.businessName" placeholder="请输入商机名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="款项名称" prop="paymentNameList">
            <el-select v-model="queryParams.paymentNameList" placeholder="请选择款项名称" allow-create filterable multiple clearable style="width:100%">
              <el-option v-for="dict in paymentOptions" :key="dict.dictLabel" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="计划回款日期" prop="planFundDate">
            <el-date-picker v-model="queryParams.planFundDate" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="回款进度" prop="achieveProgressType">
            <el-select v-model="queryParams.achieveProgressType" placeholder="请选择回款进度" clearable style="width:100%">
              <el-option v-for="dict in progressOptions" :key="dict.code" :label="dict.name" :value="dict.code"/>
            </el-select>
          </el-form-item>
        </el-col>
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams"></dept-user-select>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

<!--    <el-row :gutter="10" class="mb8">-->
<!--      <el-col :span="1.5">-->
<!--        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>-->
<!--      </el-col>-->
<!--      <el-col :span="1.5">-->
<!--        <el-button type="primary" icon="el-icon-user" :disabled="multiple" @click="handleAssign">分配</el-button>-->
<!--      </el-col>-->
<!--      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>-->
<!--    </el-row>-->
    <el-row style="margin: 10px 0;">
      <el-col :span="24">
        <div style="font-size: 14px; margin: 5px 0">
          <span style="margin-right: 40px">计划总回款（元）：{{ amountFormat(otherData.totalPlanFundAmount / 10000) }}万</span>
          <span style="margin-right: 40px">实际回款金额（元）：{{ amountFormat(otherData.totalActualAmount / 10000) }}万</span>
          <span>回款总进度：{{ otherData.totalFundProcess || 0 }}%</span>
        </div>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" align="center"/>
      <el-table-column label="合同编号" min-width="90" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail(scope.row)">{{scope.row.contractNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="签约客户" min-width="110" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail(scope.row)">{{scope.row.customerName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="商机" min-width="110" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toBusinessDetail(scope.row)">{{scope.row.businessName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="合同总额(元)" width="120" align="center">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.contractTotalAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="期数" width="100" align="center" prop="planFundBatch"/>
      <el-table-column label="款项名称" width="100" align="center" prop="paymentName"/>
      <el-table-column label="款项比例" width="100" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.paymentRatio}}%</span>
        </template>
      </el-table-column>
      <el-table-column label="计划回款日期" width="100" align="center" prop="planFundDate"/>
      <el-table-column label="计划回款(元)" width="100" align="center">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.planFundAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="实际回款(元)" width="100" align="center">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.actualAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="达成进度" width="100" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.achieveProgress}}%</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" width="100" align="center" prop="remark"/>
      <el-table-column label="负责人" width="80" align="center" prop="managerName" />
      <!-- <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text"  @click="handleFollow(scope.row)">跟进</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <AssignDialog ref="assignDialogRef" @success="getList"></AssignDialog>
    <FollowAddDialog ref="followAddDialogRef" @success="getList"></FollowAddDialog>
    <AddPlanFundDialog ref="addPlanFundDialogRef" @success="getList"></AddPlanFundDialog>
  </div>
</template>

<script>
import { listPageContractPlanFund } from "@/api/crm/planFund";
import UserSelect from "@/views/crm/components/userSelect";
import AssignDialog from "@/views/crm/components/assignDialog";
import FollowAddDialog from "@/views/crm/follow/followAddDialog";
import AddPlanFundDialog from "@/views/crm/planFund/addPlanFundDialog";
import { mapState } from 'vuex'
import { amountFormat } from '@/utils/index'
import deptUserSelect from "@/views/crm/components/deptUserSelect";
import customerSelect from "@/views/crm/components/customerSelect";

export default {
  name: "PlanFundManage",
  data() {
    return {
      amountFormat,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      paymentOptions: [], // 款项名称
      progressOptions: [{
        code: '1',
        name: '0%',
      }, {
        code: '2',
        name: '0% < 进度 < 50%',
      }, {
        code: '3',
        name: '50% ≤ 进度 < 100%',
      }, {
        code: '4',
        name: '100%',
      }], // 1: 0, 2：(0-50) 3：[50-100) 4：100
      // 总条数
      total: 0,
      dataList: [],
      otherData: {
        totalActualAmount: 0,
        totalFundProcess: 0,
        totalPlanFundAmount: 0
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractNum: null,
        customerName: null,
        achieveProgressType: null,
        deptIdList: [],
        managerIdList: [],
        businessName: null,
        paymentNameList: [],
        planFundDate: null
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    AssignDialog,
    FollowAddDialog,
    AddPlanFundDialog,
    deptUserSelect,
    customerSelect
  },
  created() {
    if (!this.$route.query.isAll) {
      this.queryParams.managerIdList = [this.currentUserId]
    }
    this.getDicts("payment_name").then(response => {
      this.paymentOptions = response.data;
    });
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.planFundDate && params.planFundDate.length > 1) {
        params.planFundDateStart = params.planFundDate[0]
        params.planFundDateEnd = params.planFundDate[1]
      }
      params.planFundDate = null;
      let tempParams = {}
      for(let i in params){
        if(params[i]){
          tempParams[i] = params[i]
        }
      }
      listPageContractPlanFund(tempParams).then(response => {
          this.dataList = response.rows || [];
          this.otherData = response.otherData || {}
          this.total = response.total;
          this.loading = false;
      }).catch(error => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !selection.length;
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/plan-fund/detail/" + row.id, "_blank")
    },
    /** 详细按钮操作 */
    toContractDetail(row) {
      window.open("/crm/contract/detail/" + row.contractId, "_blank")
    },
    /** 详细按钮操作 */
    toCustomerDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    /** 详细按钮操作 */
    toBusinessDetail(row) {
      window.open("/crm/business/detail/" + row.businessId, "_blank")
    },
    /** 跟进按钮操作 */
    handleFollow(row) {
      this.$refs.followAddDialogRef.open("contractPlanFund", row.id);
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.addPlanFundDialogRef.open();
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.batchAssign("contractPlanFund", this.ids)
    }
  }
};
</script>
